import React, { useState, useEffect } from 'react';
import { Alert, Row, Col } from 'reactstrap';

const GmailSpamAlert = ({profile}) => {
  const [isAlertOpen, setAlertOpenState] = useState(false);

  const hideAlert = () => {
    localStorage.setItem('GMAIL_alert_hidden', true);
    setAlertOpenState(false);
  };

  useEffect(() => {
    const isAlertHidden = localStorage.getItem('GMAIL_alert_hidden');

    !isAlertHidden && profile.email.match(/@gmail\.com/) && setAlertOpenState(true);
  }, []);

  return (
    <Alert color="success" isOpen={isAlertOpen} toggle={hideAlert}>
      <Row>
        <Col xs="12" md="4" xl="5" className="gmail-alert-primary">
          Внимание!<br/>Всем, у кого почтовый ящик Gmail,<br />просьба проверить папку "Спам".
        </Col>
        <Col xs="12" md="8" xl="7" className="gmail-alert-secondary">
          Чтобы не пропускать важные сообщения, связанные с Вашим аккаунтом, необходимо проверить папку "Спам",
          открыть одно из писем от <strong>OFFERRUM</strong> и нажать кнопку <strong>"Не спам"</strong> / <strong>"Report not spam"</strong>,
          после чего следующие письма начнут приходит в папку <strong>"Входящие"</strong>.
        </Col>
      </Row>
    </Alert>
  );
};

export default GmailSpamAlert;
